import React, { useEffect } from 'react'
import { Routes, Route, matchPath, useLocation } from 'react-router-dom'
import Providers from './bootstrap/Providers'
import { publicRoutes } from './routes/PublicRoutes'
import { protectedRoutes } from './routes/ProtectedRoutes'
import { renderRoutes, PITCH_DECK_RENDER_PATH } from './routes/RenderRoutes'
import NotFoundContainer from './modules/404'
import { dismissBootPreloader } from './common/boot-preloader'
import { preloadRoute } from './routes/route-preload'
import './application.scss'

function StudioApp () {
  // The boot screen in `public/index.html` covers the gap before this bundle
  // arrives. An effect is the earliest point at which React has both committed
  // and painted, so taking it down here can never expose a blank frame.
  useEffect(() => {
    dismissBootPreloader()

    // Start this route's chunk now, alongside the sign-in it would otherwise
    // queue behind. `/auth/callback` asks again once it has read where it is
    // going; the second call joins the first request rather than repeating it.
    // eslint-disable-next-line no-undef
    preloadRoute(window.location.pathname)
  }, [])

  return (
    <Providers>
      <Routes>
        {publicRoutes}
        {protectedRoutes}
        <Route path='*' element={<NotFoundContainer />} />
      </Routes>
    </Providers>
  )
}

function App () {
  const { pathname } = useLocation()

  // The PDF export Lambda's render target skips the app shell: no auth boot to
  // wait on or fail, no analytics. Its container takes down the boot screen.
  if (matchPath(PITCH_DECK_RENDER_PATH, pathname)) return <Routes>{renderRoutes}</Routes>

  return <StudioApp />
}

export default App
